import { render } from "./diseaseSelector.vue?vue&type=template&id=18b58b9e&scoped=true"
import script from "./diseaseSelector.vue?vue&type=script&lang=js"
export * from "./diseaseSelector.vue?vue&type=script&lang=js"

import "./diseaseSelector.vue?vue&type=style&index=0&id=18b58b9e&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b58b9e"]])

export default __exports__